// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_POST_EDIT_MENU = "Uprav";
